import { EXPORT_ISSUES } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case EXPORT_ISSUES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case EXPORT_ISSUES.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case EXPORT_ISSUES.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
